import { ApolloLink } from '@apollo/client';
import posthog from 'posthog-js/dist/module.slim';

import { POSTHOG_COOKIE_KEY } from '../utils/constants';
import { getBrowserPosthogDistinctId, getDistinctIdFromPosthogBootstrapCookie } from '../utils/helpers/get-posthog-distinct-id';

/**
 * Adds x-posthog-id header containing the PostHog distinct ID.
 */
export const createPosthogIdLink = (cookieHeader?: string) =>
  new ApolloLink((operation, forward) => {
    operation.setContext((context: { headers?: Record<string, unknown> }) => {
      const distinctId = getPosthogDistinctId(cookieHeader);
      if (!distinctId) return context;

      return {
        ...context,
        headers: {
          ...context.headers,
          'x-posthog-id': distinctId,
        },
      };
    });

    return forward(operation);
  });

const getPosthogDistinctId = (cookieHeader?: string): string | undefined => {
  try {
    if (cookieHeader) {
      const raw = parseCookie(cookieHeader, POSTHOG_COOKIE_KEY);
      return raw ? getDistinctIdFromPosthogBootstrapCookie(decodeURIComponent(raw)) : undefined;
    }

    if (globalThis.window !== undefined) {
      return getBrowserPosthogDistinctId(posthog?.get_distinct_id?.());
    }
  } catch {
    return undefined;
  }

  return undefined;
};

const parseCookie = (cookieStr: string, key: string): string | undefined =>
  cookieStr.split(';').reduce<string | undefined>((found, cookie) => {
    if (found) return found;

    const trimmedCookie = cookie.trim();
    const separatorIndex = trimmedCookie.indexOf('=');
    if (separatorIndex === -1) return undefined;

    return trimmedCookie.slice(0, separatorIndex) === key ? trimmedCookie.slice(separatorIndex + 1) : undefined;
  }, undefined);
